import styled from 'styled-components';

// 窗口整体的容器样式
export const ChatContactContainer = styled.div`
  background-color: #ffffff;
  background-image: linear-gradient(to bottom, ${(props) => props.$themeColor ?? '#3F5773'}, white 60%, white);
  background-size: 10% 100%;
  padding: 35px 15px 35px 15px;
  height: 100%;
  box-sizing: border-box;
  overflow-y: hidden;
`;

export const TitleText = styled.div`
  white-space: pre;
  color: #ffffff;
  font-size: 23px;
  font-weight: 400;
  line-height: 35px;
`;

export const CardContainer = styled.div`
  background-color: #ffffff;
  border-radius: 5px;
  margin: 30px 0;
  padding: 15px 10px 15px 10px;
  box-sizing: border-box;
  max-height: calc(100% - 240px);
  //box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 0 10px -10px rgba(0, 0, 0, 0.1), 0 0 10px -10px rgba(0, 0, 0, 0.1), 0 3px 8px 0 rgba(0, 0, 0, 0.1),
    0 0 5px 0px rgba(0, 0, 0, 0.1);
  overflow-y: auto;
  ::-webkit-scrollbar {
    width: 6px; /* 横向滚动条宽度，这里设置为较小的 6px，你可按需调整 */
    height: 20px; /* 纵向滚动条高度，这里设置为较小的 6px，你可按需调整 */
  }

  /* 滚动条轨道样式 */
  ::-webkit-scrollbar-track {
    background-color: #f1f1f1; /* 轨道背景颜色，这里用浅灰色示例，可更改 */
    border-radius: 10px; /* 轨道圆角，使滚动条外观更圆润 */
  }

  /* 滚动条滑块样式 */
  ::-webkit-scrollbar-thumb {
    background-color: #888; /* 滑块的灰色颜色 */
    border-radius: 10px; /* 滑块圆角 */
  }

  /* 鼠标悬停在滑块上时的样式 */
  ::-webkit-scrollbar-thumb:hover {
    background-color: #555; /* 鼠标悬停时滑块颜色变深 */
  }
`;

export const CustomerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
export const Title = styled.div`
  color: #333333;
  font-size: 16px;
`;
export const SubTitle = styled.div`
  color: #666666;
  font-size: 12px;
`;
export const GoToButton = styled.div`
  background: ${(props) => props.$themeColor ?? '#3F5773'};
  border-radius: 50%;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  img {
    width: 18px;
    height: 12px;
  }
`;
export const ContactIconContainer = styled.div`
  padding-top img {
    margin-right: 15px;
    width: 30px;
    height: 30px;
    cursor: pointer;
  }
`;
export const HistoryWrapper = styled.div`
  overflow: hidden;
  height: calc(100% - 50px);
  div:last-of-type {
    border: none;
    padding-bottom: 0;
  }
  div:first-of-type {
    padding-top: 0;
  }
`;
export const HistoryItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 10px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
`;
export const HistoryIcon = styled.div`
  svg {
    width: 30px;
    height: 30px;
  }
`;
export const HistoryMessageWrapper = styled.div`
  width: calc(100% - 100px);
  margin: 0 20px;
`;
export const HistoryTime = styled.div`
  color: #666666;
  font-size: 12px;
  margin-bottom: 5px;
`;
export const HistoryText = styled.div`
  color: #000000;
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ChatContainerDetail = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #ffffff;
  padding-bottom: 50px;
  height: 100%;
  box-sizing: border-box;
  overflow-y: scroll;
`;
export const ContactIcon = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 50px;
  img {
    width: 50px;
    height: 50px;
  }
`;
export const ContactName = styled.div`
  margin-top: 20px;
  font-size: 16px;
  color: #000000;
`;

export const ContactCode = styled.div`
  margin-top: 30px;
`;
export const ContactCodeTipsText = styled.div`
  margin-top: 20px;
  font-size: 12px;
  color: #999999;
`;
export const ContactOpenButton = styled.div`
  background: ${(props) => props.$themeColor ?? '#3F5773'};
  border-radius: 5px;
  margin-top: 30px;
  padding: 6px 18px;
  font-size: 12px;
  color: #ffffff;
  cursor: pointer;
`;
export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  // position: absolute;
  // padding: 15px 10px;
  // width: 100%;
  // width: calc(100% - 50px);
  background: #fff;
  // left: 15px;
  // margin-top: -40px;
  // border-radius: 5px;
`;
export const NewSessionContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 3px 8px;
  border-width: 1px;
  border-radius: 4px;
  border-style: solid;
  border-color: ${(props) => props.$themeColor ?? '#3F5773'};
  > span {
    color: ${(props) => props.$themeColor ?? '#3F5773'};
    font-size: 14px;
    margin-left: 4px;
  }
  &:hover {
    background-color: ${(props) => props.$chatservicecolor ?? '#3F5773'};
  }
`;
